module.exports = __webpack_public_path__ + "applemango/img/no_result_found.649e2cf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no_result_found.gif
// module id = zRg+
// module chunks = 75